var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Item Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59994 0.5H14.3999C15.2836 0.5 15.9999 1.33947 15.9999 2.375V13.625C15.9999 14.6605 15.2836 15.5 14.3999 15.5H1.59994C0.716283 15.5 -6.10352e-05 14.6605 -6.10352e-05 13.625V2.375C-6.10352e-05 1.33947 0.716283 0.5 1.59994 0.5ZM13.2812 6.5H2.71869C2.04559 6.5 1.49994 7.08763 1.49994 7.8125V8.25H5.22589C5.44138 8.25 5.64804 8.34219 5.80042 8.50628L6.61292 9.38128C6.98078 9.77744 7.4797 10 7.99994 10C8.52017 10 9.0191 9.77744 9.38696 9.38128L10.1995 8.50628C10.3518 8.34219 10.5585 8.25 10.774 8.25H14.4999V7.8125C14.4999 7.08763 13.9543 6.5 13.2812 6.5ZM1.49994 4.5C1.49994 3.67157 2.04559 3 2.71869 3H13.2812C13.9543 3 14.4999 3.67157 14.4999 4.5V5H1.49994V4.5Z",
    fill: "#767A7F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionIcon2);
export default __webpack_public_path__ + "static/media/solution_icon_2.f3832118ff46e754f5292b005b080c61.svg";
export { ForwardRef as ReactComponent };